import { Icon, Icons } from '@/components/icon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { P3 } from '@/components/ui/text';
import { useTranslation } from '@/hooks/use-translation';
import type { ReactNode } from 'react';

interface ContactViewTabMenuProps {
  children: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRename: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

export function ContactViewTabMenu({
  children,
  open,
  onOpenChange,
  onRename,
  onDuplicate,
  onDelete,
}: ContactViewTabMenuProps) {
  const { t } = useTranslation('desktop_ui');

  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[160px]">
        <DropdownMenuItem onClick={onRename} className="cursor-pointer gap-2">
          <Icon className="text-body-14 text-primary-60" name={Icons.NotePencil} />
          <P3>{t('components.contacts.views.menu.edit')}</P3>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDuplicate} className="cursor-pointer gap-2">
          <Icon className="text-body-14 text-primary-60" name={Icons.Copy} />
          <P3>{t('components.contacts.views.menu.duplicate')}</P3>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDelete} variant="danger" className="cursor-pointer gap-2">
          <Icon className="text-body-14" name={Icons.Bin} />
          <P3>{t('components.contacts.views.menu.delete')}</P3>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
